var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FF188F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.93 18C15.633 18 15.3787 17.8951 15.1672 17.6853C14.9557 17.4754 14.85 17.2232 14.85 16.9286V9.07143C14.85 8.77679 14.9557 8.52455 15.1672 8.31473C15.3787 8.10491 15.633 8 15.93 8H16.92C17.217 8 17.4712 8.10491 17.6827 8.31473C17.8942 8.52455 18 8.77679 18 9.07143V16.9286C18 17.2232 17.8942 17.4754 17.6827 17.6853C17.4712 17.8951 17.217 18 16.92 18H15.93ZM10.08 18C9.783 18 9.52875 17.8951 9.31725 17.6853C9.10575 17.4754 9 17.2232 9 16.9286V9.07143C9 8.77679 9.10575 8.52455 9.31725 8.31473C9.52875 8.10491 9.783 8 10.08 8H11.07C11.367 8 11.6212 8.10491 11.8327 8.31473C12.0442 8.52455 12.15 8.77679 12.15 9.07143V16.9286C12.15 17.2232 12.0442 17.4754 11.8327 17.6853C11.6212 17.8951 11.367 18 11.07 18H10.08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStop);
export default __webpack_public_path__ + "static/media/iconStop.6cf81339.svg";
export { ForwardRef as ReactComponent };